function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
var PANEL = {
  LEFT: 'left',
  RIGHT: 'right'
};

/**
 * Status: *In progress*.
 * Category: FormElements
 */
var ToggleSwitch = function ToggleSwitch(_ref) {
  var _classnames;
  var leftLabel = _ref.leftLabel,
    rightLabel = _ref.rightLabel,
    leftOnClickHandler = _ref.leftOnClickHandler,
    rightOnClickHandler = _ref.rightOnClickHandler,
    active = _ref.active,
    backgroundColor = _ref.backgroundColor,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('toggle-switch', (_classnames = {}, _defineProperty(_classnames, "toggle-switch__".concat(backgroundColor), true), _defineProperty(_classnames, className, className), _classnames)),
    role: "group"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-pressed": active === PANEL.LEFT,
    className: "toggle-switch__button",
    onClick: leftOnClickHandler
  }, leftLabel), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-pressed": active === PANEL.RIGHT,
    className: "toggle-switch__button",
    onClick: rightOnClickHandler
  }, rightLabel));
};
ToggleSwitch.defaultProps = {
  leftOnClickHandler: function leftOnClickHandler() {},
  rightOnClickHandler: function rightOnClickHandler() {},
  backgroundColor: 'white'
};
ToggleSwitch.propTypes = {
  active: PropTypes.oneOf(Object.keys(PANEL).map(function (k) {
    return PANEL[k];
  })),
  backgroundColor: PropTypes.oneOf(['white', 'grey']),
  className: PropTypes.string,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  leftOnClickHandler: PropTypes.func,
  rightOnClickHandler: PropTypes.func
};
export default ToggleSwitch;